import axios from "axios";

// MUST have lint rule or will not build in production (yarn run build)
/* eslint-disable no-useless-escape */
export function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const GOOGLE_API_KEY = 'AIzaSyAndBcJxUZ8kZdwlUcCNOrN_z-bAZFoM3E'; // Frontend-only key, restricted by HTTP referrer in Google Cloud Console

export const AWS_S3_BASE_URL = `https://bplacedprivate.s3.eu-west-2.amazonaws.com`;

// Use the current origin (same domain as the frontend) for API requests
// This works for localhost, ngrok, App Runner, and any custom domain
export const serverUrl =
  window.location.href.includes("localhost") || window.location.href.includes("ngrok")
    ? "http://localhost"
    : window.location.origin;

export const fetcher = (url) => axios.get(url).then((res) => res.data);

export const swrConfig = {
  // Important, can cause page re-render and mess up forms when just switching tabs
  revalidateOnFocus: false,
  // Important: Never retry the request if failed, e.g. not authenticated
  shouldRetryOnError: false,
};

export function requestLocation(callback) {
  if (navigator.geolocation) {
    // callback returns:
    // position.coords: {latitude, longitude}
    navigator.geolocation.getCurrentPosition(callback);
  } else {
    console.log("Geolocation not supported");
  }
}

export const MESSAGES_USER_TYPE = {
  LA: "LA",
  PROVIDER: "PROVIDER",
};

export function getMessagesUserType(user) {
  if (user.localAuthorityId) {
    return MESSAGES_USER_TYPE.LA;
  }

  if (user.careProviderOrganisationId) {
    return MESSAGES_USER_TYPE.PROVIDER;
  }

  return "";
}

export const INPUT_DATE_FORMAT = "yyyy-MM-dd";

export function uploadPresignedFile({
  presignedurl,
  file,
  acl = "private",
  onSuccess,
  onFail,
  onProgress,
}) {
  // from http://blog.rudikovac.com/react-native-upload-any-file-to-s3-with-a-presigned-url/
  const xhr = new XMLHttpRequest();

  xhr.upload.addEventListener(
    "progress",
    (e) => {
      if (onProgress && typeof onProgress === "function") {
        onProgress(e);
      }
    },
    false
  );

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        // Successfully uploaded the file.
        console.log("----- Successfully uploaded pre-signed url");

        if (onSuccess && typeof onSuccess === "function") {
          onSuccess({ file: file, response: xhr });
        }
      } else {
        // The file could not be uploaded.
        console.log("failed to upload presignedurl");
        console.log(xhr);

        if (onFail && typeof onFail === "function") {
          onFail(file.uri);
        }
      }
    }
  };

  xhr.open("PUT", presignedurl);
  xhr.setRequestHeader("X-Amz-ACL", acl);
  // for text file: text/plain, for binary file: application/octet-stream
  xhr.setRequestHeader("Content-Type", file.type);
  xhr.send(file);
}

export const formIconStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: 44,
  flexGrow: 0,
  marginTop: 8,
};

export function scrollTop() {
  // Finally scroll the app wrapper to the top (NOT window!)
  const appWrapperClass = document.getElementsByClassName("bplaced-inner");
  if (appWrapperClass?.length > 0) {
    appWrapperClass[0].scrollTop = 0;
  }
}

export function getIconType(type) {
  if (type.includes("pdf")) {
    return `bi-file-earmark-pdf`;
  }

  if (type.includes("doc")) {
    return `bi-file-earmark-text`;
  }

  if (type.includes("xls") || type.includes("csv") || type.includes("excel")) {
    return `bi-file-earmark-bar-graph`;
  }

  if (type.includes("presentation") || type.includes("powerpoint")) {
    return `bi-file-earmark-slides`;
  }

  if (type.includes("zip")) {
    return `bi-file-earmark-zip`;
  }

  // Generic
  return `bi-file-earmark`;
}
